import React from 'react';
import { Tooltip, Typography } from 'antd';
import isEmpty from 'lodash/isEmpty';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';
import { IntlMessages } from '@/components';

const { Title } = Typography;

const UnpublishedChangesWarningHeader = ({ showUnpublishedChangesTooltip, updatedFields, localeId }) => {
  const intl = useIntl();

  return (
    <Title className="hp-mb-24" level={4}>
      {intl.formatMessage({ id: localeId })}
      {showUnpublishedChangesTooltip && (
        <Tooltip
          className="hp-ml-4"
          placement="right"
          title={
            <>
              <IntlMessages id="ui-general-unpublished-tooltip-title" />
              {` ${!isEmpty(updatedFields) ? updatedFields?.join(', ') : '-'}`}
            </>
          }
        >
          &nbsp;
          <ExclamationCircleOutlined className="hp-text-color-warning-1" />
        </Tooltip>
      )}
    </Title>
  );
};

export default UnpublishedChangesWarningHeader;
